import React from 'react';
import { Button } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { useStyles } from './useStyles';

export const CopyInputActions = ({ className, editMode, disabled, onEdit, onSave, onCancel }) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.root, className)}>
      {editMode ? (
        <>
          <Button
            onClick={onCancel}
            disabled={disabled}
            variant="text"
            size="small"
          >
            Cancel
          </Button>

          <Button
            className={styles.grayButton}
            onClick={onSave}
            disabled={disabled}
            variant="contained"
            color="primary"
            size="small"
          >
            Save text
          </Button>
        </>
      ) : (
        <Button
          className={styles.grayButton}
          onClick={onEdit}
          disabled={disabled}
          variant="contained"
          color="primary"
          size="small"
        >
          Edit
        </Button>
      )}
    </div>
  );
};

CopyInputActions.propTypes = {
  className: PropTypes.string,
  editMode: PropTypes.bool,
  disabled: PropTypes.bool,
  onEdit: PropTypes.func,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
};

CopyInputActions.defaultProps = {
  className: null,
  editMode: false,
  disabled: false,
  onEdit: null,
  onSave: null,
  onCancel: null,
};
